var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cities"
  }, [_c('div', {
    staticClass: "text-2xl font-bold mb-6"
  }, [_vm._v("Master Data City")]), _c('div', {
    staticClass: "border shadow-lg rounded-md bg-white"
  }, [_c('div', {
    staticClass: "p-6 flex justify-between"
  }, [_c('div', {
    staticClass: "flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-60"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "action": _vm.doSearch,
      "placeholder": "Masukan kata kunci"
    },
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  })], 1), _c('div', {}, [_c('Button', {
    attrs: {
      "buttonText": "Cari"
    },
    on: {
      "action": function ($event) {
        return _vm.doSearch();
      }
    }
  })], 1)])]), _c('TableComponent', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('td', {
          staticClass: "w-16 text-center"
        }, [_vm._v("No.")]), _c('td', {
          staticClass: "w-96"
        }, [_vm._v("Nama")]), _c('td', {
          staticClass: "w-96"
        }, [_vm._v("Kode")]), _c('td', [_vm._v("Kode Kota")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function () {
        return [_vm.filteredData && _vm.filteredData.length > 0 ? _vm._l(_vm.filteredData, function (item, index) {
          return _c('tr', {
            key: item.code
          }, [_c('td', {
            staticClass: "w-16 text-center"
          }, [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.perPage + (index + 1)))]), _c('td', {
            staticClass: "w-96"
          }, [_vm._v(_vm._s(item.name))]), _c('td', {
            staticClass: "w-96"
          }, [_vm._v(_vm._s(item.code))]), _c('td', [_vm._v(_vm._s(item.city_code))])]);
        }) : [_c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "5"
          }
        }, [_c('div', {
          staticClass: "py-6"
        }, [_vm._v("Tidak ada data yang tersedia.")])])])]];
      },
      proxy: true
    }])
  }), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "px-6 text-sm text-neutral-500"
  }, [_vm._v("Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.total) + " data.")]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "my-6 flex justify-center px-4"
  }, [_c('pagination', {
    attrs: {
      "total-pages": _vm.totalPages,
      "total": _vm.total,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "has-more-pages": _vm.hasMorePages
    },
    on: {
      "pagechanged": _vm.showMore
    }
  })], 1) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }